import { render, staticRenderFns } from "./DGroupMenu.vue?vue&type=template&id=37a2c444&scoped=true&"
import script from "./DGroupMenu.vue?vue&type=script&lang=js&"
export * from "./DGroupMenu.vue?vue&type=script&lang=js&"
import style0 from "./DGroupMenu.vue?vue&type=style&index=0&id=37a2c444&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a2c444",
  null
  
)

export default component.exports